import { SingleStar } from '@energy-retailer/icons';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import type { StarRatingProps } from './index.types';

const ratingLevels = [1, 2, 3, 4, 5];

export const StarRating = ({ rating }: StarRatingProps) => (
  <div className="flex gap-a">
    {ratingLevels.map((level) => (
      <SingleStar
        data-testid="rating-star-icon"
        key={level}
        className={twMerge(
          clsx('h-icon w-icon fill-pink-200 text-pink-200', {
            'fill-pink-500 text-pink-500': level <= rating,
          })
        )}
      />
    ))}
  </div>
);
